import {Box, Container, Grid, Typography} from "@mui/material";
import {CustomButton} from "../../../../shared/components/Buttons/CustomButton";
import {useLangContext} from "../../../../shared/features/Language";
import {useContext, useEffect} from "react";
import {ImageContext} from "../../../../shared/tools/image/imageContext";
import {useHistory} from "react-router-dom";
import kitImage from '../../../../shared/assets/img/kit.jpg';

import './quantityView.scss';


export const QuantityView = () => {
  const {textData} = useLangContext();
  const {setQuantity, quantity} = useContext(ImageContext);
  const history = useHistory();

  useEffect(() => {
    setQuantity('');
  },[]);

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuantity(e.target.value);
  };

  return (
    <Container
      sx={{
        height: '100%',
        maxWidth: '980px',
        marginInline: 'auto',
      }}
      className='quantity-view'
    >
      <Box sx={{
        textAlign: 'center',
      }}>
        <Typography
          variant='body2'
          sx={{
            marginBottom: {lg: '40px', xs: '10px'},
          }}
        >{textData.motivationQuantitySelect}</Typography>
        <div className='quantity-options'>
          <div className="quantity-options_item">
            <label>
              <div className="quantity-options_img">
                <img src={kitImage} alt="Mix Bricks Kit"/>
              </div>
              <div className="input-wrapper">
                <input type="radio" name='quantity' onChange={(e) => onChangeHandler(e)} value="1"/>
                <div className="radio"></div>
                {textData.quantityOption1}
              </div>
            </label>
          </div>

          {/*<div className="quantity-options_item">*/}
          {/*  <label>*/}
          {/*    <div className="quantity-options_img"></div>*/}
          {/*    <div className="input-wrapper">*/}
          {/*      <input type="radio" name='quantity' onChange={(e) => onChangeHandler(e)} value="2"/>*/}
          {/*      <div className="radio"></div>*/}
          {/*      {textData.quantityOption2}*/}
          {/*    </div>*/}
          {/*  </label>*/}
          {/*</div>*/}
          {/*<div className="quantity-options_item">*/}
          {/*  <label>*/}
          {/*    <div className="quantity-options_img"></div>*/}
          {/*    <div className="input-wrapper">*/}
          {/*      <input type="radio" name='quantity' onChange={(e) => onChangeHandler(e)} value="3"/>*/}
          {/*      <div className="radio"></div>*/}
          {/*      {textData.quantityOption3}*/}
          {/*    </div>*/}
          {/*  </label>*/}
          {/*</div>*/}

        </div>

        <Grid container
              sx={{
                gap: '50px',
                justifyContent: 'center',
                marginTop: '45px',
              }}
        >
          <Grid item>
            <CustomButton
              color='secondary'
              width='200px'
              onClick={()=>{history.goBack()}}
            >{textData.buttonCaptionBack}</CustomButton>
          </Grid>
          <Grid item>
            <CustomButton
              width='200px'
              onClick={()=>{history.push('/image-upload')}}
              disabled={!quantity}
            >{textData.buttonCaptionNext}</CustomButton>
          </Grid>
        </Grid>


      </Box>
    </Container>
  )
}
